// @flow

import { connect } from "react-redux";

import Launch from "src/components/chatroom/Dialog/Launch";
import { closeConversationModal } from "src/actions/chatroom";
import {
  getChatroomAddress,
  getTemplateId,
  getChatroomTitle
} from "src/reducers";

const mapStateToProps = ({ app }, { roomId }) => {
  return {
    address: getChatroomAddress(app, roomId),
    templateId: getTemplateId(app, roomId),
    title: getChatroomTitle(app, roomId)
  };
};

export default connect(mapStateToProps, { closeConversationModal })(Launch);
